var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7704 2.60371C11.7704 1.97862 11.5235 1.37914 11.0841 0.93714C10.6447 0.49514 10.0487 0.246826 9.42729 0.246826H6.30316C5.68173 0.246826 5.08576 0.49514 4.64634 0.93714C4.20693 1.37914 3.96007 1.97862 3.96007 2.60371H3.17903C2.55761 2.60371 1.96163 2.85202 1.52221 3.29402C1.0828 3.73602 0.835938 4.3355 0.835938 4.96058V11.2456C0.835938 11.8707 1.0828 12.4702 1.52221 12.9122C1.96163 13.3542 2.55761 13.6025 3.17903 13.6025H12.5514C13.1728 13.6025 13.7688 13.3542 14.2082 12.9122C14.6477 12.4702 14.8945 11.8707 14.8945 11.2456V4.96058C14.8945 4.3355 14.6477 3.73602 14.2082 3.29402C13.7688 2.85202 13.1728 2.60371 12.5514 2.60371H11.7704ZM9.42729 1.81808H6.30316C6.09602 1.81808 5.89736 1.90085 5.75089 2.04818C5.60442 2.19552 5.52213 2.39534 5.52213 2.60371H10.2083C10.2083 2.39534 10.126 2.19552 9.97956 2.04818C9.83309 1.90085 9.63443 1.81808 9.42729 1.81808ZM3.17903 4.17496H12.5514C12.7586 4.17496 12.9572 4.25773 13.1037 4.40506C13.2502 4.5524 13.3325 4.75222 13.3325 4.96058V11.2456C13.3325 11.454 13.2502 11.6538 13.1037 11.8011C12.9572 11.9485 12.7586 12.0312 12.5514 12.0312H3.17903C2.97189 12.0312 2.77323 11.9485 2.62676 11.8011C2.48029 11.6538 2.398 11.454 2.398 11.2456V4.96058C2.398 4.75222 2.48029 4.5524 2.62676 4.40506C2.77323 4.25773 2.97189 4.17496 3.17903 4.17496Z",
    fill: "#727D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile3);
export default __webpack_public_path__ + "static/media/profile3.73d97980cd1250cfb29bc57948bf2e96.svg";
export { ForwardRef as ReactComponent };